import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '../i18n'

// LIB
import Age from '@/lib/Age.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    kidDOB: '',
    kidsAgeM: '',
    kidsAgeFull: '',
    questData: ''
  },
  mutations: {
    setKidsAge(state, $date) {
      const $age = Age.getAge($date)
      const years = i18n.locale === 'en' ? ' years and ' : ' ετών και '
      const year = i18n.locale === 'en' ? ' years and ' : ' έτους και '
      const months = i18n.locale === 'en' ? ' months' : ' μηνών'

      state.kidDOB = $date
      state.kidsAgeM = $age.months + ($age.years * 12)
      state.kidsAgeFull = $age.years + years + $age.months + months
      if ($age.years === 1) state.kidsAgeFull = $age.years + year + $age.months + months
    },
    setQuestData(state, $data) {
      state.questData = $data
    }
  }
})
